import { render, staticRenderFns } from "./DialogWeChatScan.vue?vue&type=template&id=a01c0874"
import script from "./DialogWeChatScan.vue?vue&type=script&lang=js"
export * from "./DialogWeChatScan.vue?vue&type=script&lang=js"
import style0 from "./DialogWeChatScan.vue?vue&type=style&index=0&id=a01c0874&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports